import { Dispatch, SetStateAction, useState } from "react";
import { SaveButton } from "../../UtilitiesComponents/SaveButton";
import { ValidFormCompnentes } from "../EditComponents/AddCommentChangeStage";
import { VisitaRegister } from "../../../types/empresa";
import { Convert24HoursTo12HoursFormat } from "../../../utils/convertTimeFormat";
import { parseTaskDate, reverseDate } from "../../../utils/calendarUtils";
import { Turnos } from "../../../utils/enums";
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

interface Props {
    setCurrentComponent: Dispatch<SetStateAction<ValidFormCompnentes>>
    visitasAgregadas: VisitaRegister[];
    setVisitasAgregadas?: (visitas: VisitaRegister[]) => void;
}

export function AddedVisitas({ setCurrentComponent, visitasAgregadas, setVisitasAgregadas }: Props) {
    const [visitas, setVisitas] = useState<VisitaRegister[]>(visitasAgregadas);

    const deleteIntencion = (index: number) => {
        visitas.splice(index, 1);

        if(setVisitasAgregadas)
            setVisitasAgregadas(visitas);

        setVisitas([...visitas]);
    }

    return (
        <div>
            <SaveButton
                onClick={() => setCurrentComponent("RegisterVisita")}
                text="+ Agregar visita"
                type="button"/>

            <div className="border border-gray-300 h-[200px] mt-2 rounded">
                {visitasAgregadas.length === 0
                ? 
                <p className="text-sm font-semibold text-gray-600 italic text-center m-2">No hay visitas agregadas</p>
                :
                visitas.map((visita, index) => {
                    const horaInicio = Convert24HoursTo12HoursFormat(visita.horaInicio);
                    const horaFin = Convert24HoursTo12HoursFormat(visita.horaFin);
                    const fecha = reverseDate(parseTaskDate(visita.fecha));
                    const turno = Turnos[visita.turno];

                    return (
                        <div 
                            key={index}
                            className="flex justify-between hover:bg-slate-200 p-2 rounded-md bg-slate-50 border border-gray-500 my-2 mx-1 cursor-pointer">

                            <div className="flex gap-x-4">
                                <div className="flex gap-x-1">
                                    <p className="text-sm font-semibold">{fecha}</p>
                                </div>
                                <div>
                                    <p className="text-sm font-semibold">Turno: {turno}</p>
                                </div>

                                <div>
                                    <p className="text-sm font-semibold">Hora de inicio: {horaInicio}</p>
                                </div>

                                <div>
                                    <p className="text-sm font-semibold">Hora de fin: {horaFin}</p>
                                </div>
                            </div>

                            <div 
                                className="flex items-center h-[20px] cursor-pointer hover:bg-red-200 rounded-md duration-300 transition-all" 
                                onClick={() => deleteIntencion(index)} >
                                <CloseRoundedIcon sx={{ height: 20, width: 20 }}/>
                            </div>
                        </div>
                    );
                }) 
                }
            </div> 

        </div>
    );
}